module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jack Higgins\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v(" Jack Higgins is the "), _c('I', [_vm._v("New York Times")]), _vm._v(" bestselling author of more than sixty thrillers that have sold over 250 million copies worldwide, including "), _c('I', [_vm._v("The Eagle Has Landed")]), _vm._v(" and "), _c('I', [_vm._v("The Wolf at the Door")]), _vm._v(". Before beginning his writing career, Higgins served in the British Army along the East German border. He lives in the Channel Islands. ")], 1), _c('P', [_vm._v("   ")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/gaeaRL/tc-custom/9781453200131.jpg?1706904341260",
      "alt": "This image is the cover for the book Midnight Never Comes, The Paul Chavasse Novels"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Midnight Never Comes, The Paul Chavasse Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A former intelligence operative must stop a group of ruthless Russian spies from obtaining Britain’s newest and deadliest high-tech missile.")]), _c('br'), _c('br'), _vm._v(" For ten years, Paul Chavasse was one of Britain’s most promising intelligence agents. But when a botched mission in Albania destroyed him physically and psychologically, he was discharged from the agency a broken man."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" To regain his life of adventure, Chavasse trains under Chinese martial arts master Yuan Tao, gathering his strength and focusing his energy. And he will tackle his deadliest assignment yet: foiling a Russian plot to steal a high-powered British missile.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0